// extracted by mini-css-extract-plugin
export default {"chart":"Chart_chart__XfJw5","chartTitle":"Chart_chartTitle__DRvM9"};